export const DOWNLOAD_LOG_SQL_ROUTE = '/downloadlog-management/list-downloadlog';
export const DOWNLOAD_LOG_ELASTIC_ROUTE = '/downloadlog-management/list-downloadlog-elastic';

/** SHOW_ELASTIC_DOWNLOAD_LOG is a user-type array, same shape as SHOW_BIGDATA_SEARCH. */
export function isElasticDownloadLogEnabled(userType: string, envConfig: any): boolean {
  const allowed = Array.isArray(envConfig?.showElasticDownloadLog)
    ? envConfig.showElasticDownloadLog
    : [];
  return !!userType && allowed.includes(userType);
}

export function getDownloadLogRoute(userType: string, envConfig: any): string {
  return isElasticDownloadLogEnabled(userType, envConfig)
    ? DOWNLOAD_LOG_ELASTIC_ROUTE
    : DOWNLOAD_LOG_SQL_ROUTE;
}
